import React from "react";
import PropTypes from 'prop-types';
import { TextField } from "@material-ui/core";

import "../styles.css";

export default function CreatedBy({ values }) {

    return (
        <div className="fundoCreated">
            <div className="createdUser">
                <TextField
                    disabled
                    autoFocus
                    type="text"
                    id="criado_por"
                    margin="dense"
                    label="Criado por:"
                    variant="outlined"
                    value={values.criado_por}
                />
                <TextField
                    disabled
                    autoFocus
                    type="text"
                    id="criado_em"
                    margin="dense"
                    label="Criado em:"
                    variant="outlined"
                    value={values.criado_em}
                />
                <TextField
                    disabled
                    autoFocus
                    type="text"
                    id="editado_por"
                    margin="dense"
                    label="Editado por:"
                    variant="outlined"
                    value={values.editado_por}
                />
                <TextField
                    disabled
                    autoFocus
                    type="text"
                    id="editado_em"
                    margin="dense"
                    label="Editado em:"
                    variant="outlined"
                    value={values.editado_em}
                />
            </div>
        </div>
    )
}

CreatedBy.propTypes = {
    values: PropTypes.object,
};
